module.exports = __webpack_public_path__ + "img/default-user.bb82b771.png";